// Generated by ts-to-zod
import { z } from 'zod';
import { engineSchema } from '../models/engine.schema';

export const enginePatchPayloadSchema = engineSchema
  .partial()
  .pick({
    name: true,
    learningEnabled: true,
    description: true,
    trainingQueues: true,
  });
